import type { MaybeRefOrGetter, Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type {
  ITableFilterPresetGetPayload,
  ITableFilterResponse,
} from '../types';
import {
  TABLE_FILTER_SETS_QUERY_KEY,
  TABLE_FILTER_SETS_URL,
  TABLES_PERMISSIONS,
} from '../constants';

export default function useTableFilterPresetQuery(
  payload: Ref<ITableFilterPresetGetPayload>,
  enabled: MaybeRefOrGetter<boolean>,
): IContextQueryResult<ITableFilterResponse, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableFilterResponse, Error>({
    queryKey: [TABLE_FILTER_SETS_QUERY_KEY, payload],
    queryFn: ({ signal }) => {
      const { filterName, ...body } = payload.value;

      return fetchPost(TABLE_FILTER_SETS_URL, body, {
        signal,
        permission: TABLES_PERMISSIONS.FILTERSETS_SHOW,
        urlParams: {
          filterName,
        },
      });
    },
    enabled,
    placeholderData: keepPreviousData,
  });
}
